<template>
  <div class="analysis">
    <div class="change-box">
      <div class="item" :class="analysisIndex == index ? 'active' : ''" @click="analysisIndex = index" v-for="(item, index) in analysisList" :key="index">
        {{ item }}
      </div>
    </div>
    <qushi v-if="analysisIndex == 0"></qushi>
    <!-- <duibiao v-if="analysisIndex == 1"></duibiao> -->
    <fuhe v-if="analysisIndex == 1"></fuhe>
  </div>
</template>

<script>
import qushi from "../components/analysis/qushi";
// import duibiao from "../components/analysis/duibiao";
import fuhe from "../components/analysis/fuhe";
export default {
  components: {
    qushi,
    // duibiao,
    fuhe,
  },
  data() {
    return {
      // "对标分析",
      analysisList: ["趋势分析", "负荷分析"],
      analysisIndex: 0,
    };
  },
};
</script>
<style lang="less" scoped>
.analysis {
  .change-box {
    background: #f8f8f9;
    padding: 20px;
    padding-bottom: 0;
    display: flex;
    .item {
      font-size: 16px;
      padding-bottom: 15px;
      margin-right: 28px;
      cursor: pointer;
      &.active {
        font-weight: 600;
        border-bottom: 3px solid rgba(20, 96, 224, 1);
      }
    }
  }
}
</style>